import { ClientLogger } from 'bernie-client';
import { AdvertisingStore } from 'bernie-plugin-ads-loader-script';
import { ClientFactories, Store } from 'bernie-plugin-mobx';
import { ActivityDetailStore } from './activity-detail-store';
import { ActivitySearchStore } from './activity-search-store';
import { DetailCriteriaStore } from './detail-criteria-store';
import { SearchCriteriaStore } from './search-criteria-store';
import { TripCreationStore } from './trip-creation-store';
export { ActivitySearchStore, ActivityDetailStore, DetailCriteriaStore, AdvertisingStore };

export const stores: ClientFactories = {
  activitySearchStore: ({ bexApiContext }): Store =>
    new ActivitySearchStore(
      {},
      ClientLogger.getLoggerWithIdentifier('lx.activitySearchStore.bexapi'),
      {},
      bexApiContext
    ),
  searchCriteriaStore: ({ l10n }): Store =>
    new SearchCriteriaStore({}, ClientLogger.getLoggerWithIdentifier('lx.source.searchCriteria'), l10n),
  activityDetailStore: ({ bexApiContext }): Store =>
    new ActivityDetailStore(
      {},
      ClientLogger.getLoggerWithIdentifier('lx.activityDetailStore.bexapi'),
      {},
      bexApiContext
    ),
  detailCriteriaStore: (): Store =>
    new DetailCriteriaStore({}, ClientLogger.getLoggerWithIdentifier('lx.source.detailCriteria')),
  advertising: (): Store => new AdvertisingStore({}, ClientLogger.getLoggerWithIdentifier('lx.source.advertising')),
  tripCreationStore: (): Store =>
    new TripCreationStore({}, ClientLogger.getLoggerWithIdentifier('lx.source.tripCreation')),
};
